import InviteCard from '../InviteCard';
import RiskAlertCard from './RiskAlertCard';

/**
 * 右上角浮层堆叠：高危风险 → 同事邀请。
 * 容器负责定位与纵向排列（见 .bcc-float-stack），卡片自己不写死 top。
 */
export default function FloatStack({
  riskAlert,
  onViewRisk,
}: {
  riskAlert: { title: string; body?: string } | null;
  onViewRisk: () => void;
}) {
  return (
    <div className="bcc-float-stack">
      {riskAlert && <RiskAlertCard title={riskAlert.title} body={riskAlert.body} onView={onViewRisk} />}
      <InviteCard />
    </div>
  );
}
